import { RESET_PASSWORD } from "../configs/routes";
import { AccountLockedError, getApiErrorDetail } from "../utils/authErrors";
import api from "./api";

export const resetPassword = async (body) => {
  try {
    const response = await api.post(RESET_PASSWORD, body);
    return response.data;
  } catch (err) {
    const status = err?.response?.status;
    const detail = getApiErrorDetail(err);
    if (status === 403) throw new AccountLockedError(detail);
    throw err;
  }
};

export { getApiErrorDetail };
